export const defaultLocale = "en";
export const localeOptions = [
  { id: "en", name: "English - LTR", direction: "ltr" },
  { id: "es", name: "Español", direction: "ltr" },
  { id: "enrtl", name: "English - RTL", direction: "rtl" }
];

export const PERSIST_SCHEMA_VERSION = '19';
export const PERSIST_SCHEMA_VERSION_KEY = 'apollo-schema-version';

export const root_url = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://www.stephentaylor.ca'

export const firebaseConfig = {
  // get from firebase project settings
  apiKey: "",
    authDomain: "",
    databaseURL: "",
    projectId: "",
    storageBucket: "",
    messagingSenderId: "",
    appId: ""
};

export const graphqlURL = "https://db.stephentaylor.ca/graphql";

export const defaultDirection = "ltr";

export const CLOROTHEME = {
	"theme1": {
		"red": {
			"100": 0,
			"95": 0,
			"90": 0,
			"85": 0,
			"80": 0,
			"75": 0,
			"70": 0,
			"65": 38,
			"60": 76,
			"55": 113,
			"50": 151,
			"45": 189,
			"40": 189,
			"35": 189,
			"30": 189,
			"25": 189,
			"20": 189,
			"15": 189,
			"10": 189,
			"5": 189,
			"0": 189
		},
		"green": {
			"100": 189,
			"95": 189,
			"90": 189,
			"85": 189,
			"80": 189,
			"75": 189,
			"70": 189,
			"65": 189,
			"60": 189,
			"55": 189,
			"50": 189,
			"45": 189,
			"40": 151,
			"35": 113,
			"30": 76,
			"25": 38,
			"20": 0,
			"15": 0,
			"10": 0,
			"5": 0,
			"0": 0
		},
		"blue": {
			"100": 0,
			"95": 0,
			"90": 0,
			"85": 0,
			"80": 0,
			"75": 0,
			"70": 0,
			"65": 0,
			"60": 0,
			"55": 0,
			"50": 0,
			"45": 0,
			"40": 0,
			"35": 0,
			"30": 0,
			"25": 0,
			"20": 0,
			"15": 0,
			"10": 0,
			"5": 0,
			"0": 0
		}
	},
	"theme2": {
		"red": {
			"100": 87,
			"95": 87,
			"90": 87,
			"85": 87,
			"80": 87,
			"75": 87,
			"70": 87,
			"65": 115,
			"60": 148,
			"55": 176,
			"50": 212,
			"45": 245,
			"40": 233,
			"35": 236,
			"30": 231,
			"25": 226,
			"20": 221,
			"15": 221,
			"10": 221,
			"5": 221,
			"0": 221
		},
		"green": {
			"100": 187,
			"95": 187,
			"90": 187,
			"85": 187,
			"80": 187,
			"75": 187,
			"70": 187,
			"65": 184,
			"60": 189,
			"55": 190,
			"50": 200,
			"45": 206,
			"40": 184,
			"35": 172,
			"30": 154,
			"25": 136,
			"20": 119,
			"15": 119,
			"10": 119,
			"5": 119,
			"0": 119
		},
		"blue": {
			"100": 138,
			"95": 138,
			"90": 138,
			"85": 138,
			"80": 138,
			"75": 138,
			"70": 138,
			"65": 126,
			"60": 119,
			"55": 110,
			"50": 106,
			"45": 98,
			"40": 97,
			"35": 103,
			"30": 105,
			"25": 108,
			"20": 110,
			"15": 110,
			"10": 110,
			"5": 110,
			"0": 110
		}
	}	

}